/**
 * Note AI Edit Feature
 *
 * POC feature for testing SSE streaming with RTK Query + fakeBaseQuery
 */

import { autoRegisterFeature } from '@store/features/factory';

import { noteAiEditFeature } from './store/feature';

// Auto-register feature on module load
autoRegisterFeature(noteAiEditFeature);

// Export public API
export * from './components';
export * from './hooks';
export * from './store';
export * from './suggestionContract';
export type * from './types';
